// TODO get into theming
export const STANDARD_PADDING_X = 11
export const STANDARD_PADDING_Y = 24
